/**
 * Weitzman collection: sub-category row carousels.
 * Wires each [data-wtz-carousel] wrap's prev/next buttons to scroll its
 * track by one card-width (plus gap) at a time. Extracted verbatim from
 * sections/weitzman-collection.liquid.
 */
(function () {
  document.querySelectorAll('.wtz-subrow [data-wtz-carousel]').forEach(function (wrap) {
    const track = wrap.querySelector('[data-carousel-track]');
    const prev = wrap.querySelector('[data-carousel-prev]');
    const next = wrap.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = function () {
      const card = track.querySelector('.wtz-subrow__card');
      return card ? card.offsetWidth + 20 : 260;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();
